module.exports = __webpack_public_path__ + "img/inst4.369d5bfa.png";